import axios from 'axios'
import React, { useContext } from 'react'
import { useState } from 'react'
import { Link } from 'react-router-dom'
import { NotificationBodyWithAccessCard, NotificationViewModel } from '../../..'
import { AuthContext } from '../../../../../../context/AuthContext'
import NotificationCreator from '../../../../NotificationCreator'
import i18next from 'i18next'

const InquiryResponse = (props) => {
  const { user } = useContext(AuthContext)
  const { socket, inquiry, sender, notification } = props
  const [isClicked, setIsClicked] = useState(false)
  const activeFun = async ({ response }) => {
    try {
      setIsClicked(true)
      socket?.current?.emit('addNotifUser', sender?._id)
      // this will add the user to the default channel
      const defaultChRes = await axios.patch(
        `/channels/channelsSystem/defaultChannel/${
          inquiry?.id || inquiry?._id
        }`,
        {
          contributorId: sender?._id,
        }
      )
      NotificationCreator({
        associativity: 'inquiry',
        relation: 'inquiryReviewer',
        conditionIndex: 0,
        accompaniedData: {
          response,
          elements: [
            { ...inquiry },
            {
              hashTagType: defaultChRes?.data?.channel?.hashTagType,
              id: defaultChRes?.data?.channel?._id,
              title: defaultChRes?.data?.channel?.Title,
            },
          ],
        },
        category: 'contributors',
        userId: sender?._id,
        currentUser: user,
        socket,
      })
      if (response === 'accept')
        await axios.patch(`/inquiries/${inquiry?.id || inquiry?._id}`, {
          pairedUserId: sender?._id,
        })
      await axios.patch(`/notifications/${notification?._id}`, {
        interactedWith: true,
      })
    } catch (error) {
      console.log(error)
    }
  }
  const lang = i18next.language
  const rtl = lang === 'ar'
  const buttonsArray =
    notification?.accompaniedData?.requestSubGenre === 'start'
      ? [
          {
            title: rtl ? 'قبول' : 'Accept',
            funs: () => activeFun({ response: 'accept' }),
            disabled: isClicked || notification?.interactedWith,
          },
          {
            title: rtl ? 'رفض' : 'Refuse',
            funs: () => activeFun({ response: 'refuse' }),
            disabled: isClicked || notification?.interactedWith,
          },
        ]
      : []

  return (
    <NotificationViewModel
      {...props}
      learningSectionContent={''}
      notificationBody={
        <NotificationBodyWithAccessCard
          {...props}
          notificationBodyContent={
            <section>
              <Link to={`/profile/${sender?._id}`}>{sender.name}</Link>
              {rtl
                ? 'يسألك العمل على متطلبك'
                : `asks for working on your inquiry`}
            </section>
          }
        />
      }
      buttonsArray={buttonsArray}
    />
  )
}

export default InquiryResponse
